<template>
    <div class="main-content">
        <!-- 标题导航 -->
        <div class="nav">
            <div class="nav-area">
                <div class="return-label" @click="returnHome">
                    <img src="/photo/icon/LOGO-正钻.png" alt="首页">
                </div>
                <div class="slogan">
                    <img src="/photo/icon/slogan.png" alt="标题">
                </div>
                <div class="label">
                    <img src="/photo/icon/正品标签.png" alt="正品标签">
                </div>
            </div>
        </div>
        <!-- 软件内容 -->
        <div class="download-content">
            <!-- 软件图片 -->
            <div class="carousel" v-if="carousel">
                <div class="home-page"
                    v-for="item in list"
                    :key="item.id">
                    <img
                    v-show="brand === item.value"
                    :src="item.img"
                    :alt="item.value"/>
                </div>
            </div>
            <div :class="[marginLeft?'hide':'', 'content']">
                <div class="title">
                    {{softwareInfo.title}}
                </div>
                <div class="second-title">
                    {{softwareInfo.subtitle}}
                </div>
                <div class="version">
                    <span class="left">{{softwareInfo.version}}</span>
                </div>
                <div class="system">
                    {{softwareInfo.system}}
                </div>
                <div class="btn">
                    <!-- 软件下载按键 -->
                    <a
                        class="softare" 
                        :href="softwareInfo.downloadName"
                        target="_black">
                        <!-- <div class="test">
                            {{softwareInfo.softwareButton}}
                            <div class="img"></div>
                        </div> -->
                        {{softwareInfo.softwareButton}}
                        <div class="img"></div>
                    </a>
                    <a
                        class="softare"
                        v-if="softwareInfo.downloadName2"
                        :href="softwareInfo.downloadName2"
                        target="_black">
                        {{softwareInfo.subSoftwareButton}}
                        <div class="img"></div>
                    </a>
                    <!-- 视频教程按键 -->
                    <a
                        class="video"
                        :href="softwareInfo.url1"
                        target="_blank">
                        {{softwareInfo.videodesc1}}
                        <div class="img"></div>
                    </a>
                    <a
                        class="video"
                        v-if="softwareInfo.videodesc2"
                        :href="softwareInfo.url2"
                        target="_blank">
                        {{softwareInfo.videodesc2}}
                        <div class="img"></div>
                    </a>
                </div>
                <div class="remark">{{softwareInfo.password}}</div>
            </div>
        </div>
        <div class="application-place">
            <div class="place-list">
                <div class="list"
                    v-for="(item, index) in areaList"
                    :key="index">
                    <img :src="item.img" alt="应用场所">
                </div>
            </div>
        </div>
        <div class="process-move"></div>
        <img class="process-quiet" src="/photo/icon/软件操作流程.jpg" alt="软件流程">
    </div>
</template>

<script>
export default  {
    name: 'MainContent',
    props: {
        softwareInfo: {
            type: Object
        }
    },
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            // 控制导航的显示、隐藏
            homeIcon: 'show',
            // 控制软件展示页面的显示、隐藏
            carousel: true,
            brand: '',
            height: 0,
            marginLeft: true,
            // 软件主页面显示图数组
            list: [],
            // 应用场所列表
            areaList: [],
            // 页脚数据
            footerData: {},
            icon: ''
        }
    },
    created () {
        this.brand = this.$route.name
        // 获取时间戳
        this.getTimeStamp()
        this.request()
        this.hideCarousel() 
    },
    mounted () {
        this.changeNav()
        window.addEventListener('resize', this.resize)
    },
    methods: {
        // 获取时间戳
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 请求数据
        request () {
            this.$http.get('/mock/all.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.list = res.data.data.list
                })
            this.$http.get('/mock/area.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.areaList = res.data.data.list
                })
        },
        // 下载软件
        // download (val) {
        //     window.open(`http://www.xundean.com:8887/download/${val}.zip`)
        // },
        // openUrl (val) {
        //     window.open(`${val}`)
        // },
        resize () {
            this.hideCarousel()
            this.changeNav()
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth > 900) {
                this.marginLeft = false
            } else {
                this.marginLeft = true
            }
        },
        // 通过监控尺寸变化，显示-隐藏图片
        hideCarousel () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth < 900) {
                this.carousel = false
            } else {
                this.carousel = true
            }
        },
        // 返回brand页面
        returnHome () {
            this.homeIcon = 'hide'
            this.$router.push({ name: 'Brand' })
        },
        // 通过屏幕的宽度控制导航条的显示
        changeNav () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth < 900) {
                this.homeIcon = 'hide'
            } else {
                this.homeIcon = 'show'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main-content {
    margin: 0 auto;
    width: 1150px;
    height: 100vh;
    .nav {
        margin-top: 3px;
        height: 175px;
        background: #fff;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        .nav-area {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            margin: 0 20px;
            .return-label, .slogan, .labei {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            .return-label {
                cursor: pointer;
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .slogan {
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .label {
                img {
                    height: 175px;
                    width: 175px;
                }
            }
        }
    }
    .download-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 500px;
        background: #409EFF;
        border-radius: 1px;
        .carousel {
            width: 600px;
            height: 400px;
            img {
                margin: 5px;
                width: 600px;
                height: 400px;
                border-radius: 2px;
            }
        }
        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 30px;
            width: 350px;
            white-space: nowrap;
            overflow: hidden;
            .title {
                height: 40px;
                line-height: 40px;
                color: #fff;
                font-size: 33px;
                letter-spacing: 2px;
                font-weight: bold;
            }
            .second-title {
                margin-top: 5px;
                height: 25px;
                line-height: 25px;
                color: #fff;
                font-size:30px;
                letter-spacing: 2px;
                font-weight: bold;
            }
            .version, .system {
                margin-top: 8px;
                height: 18px;
                line-height: 18px;
                color: #fff;
                font-size:12px;
                letter-spacing: 0.2px;
            }
            .system {
                margin-top: 3px;
            }
            .btn {
                margin-top: 15px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .softare, .video, .milieu {
                    // display: block;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    position: relative;
                    width: 130px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                    font-weight: bold;
                    background: #00cd00;
                    text-decoration: none;
                    cursor: pointer;
                    border-radius: 3px;
                    & + .softare {
                        margin-top: 8px;
                    }
                    // .test {
                    //     display: flex;
                    //     flex-direction: row;
                    //     position: relative;
                    //     .img {
                    //         position: absolute;
                    //         top: 5px;
                    //         right: -25px;
                    //         margin: 5px 0 0 3px;
                    //         width: 30px;
                    //         height: 30px;
                    //         background: url(/photo/icon/1.gif) no-repeat center;
                    //     }
                    // }
                    .img {
                        position: absolute;
                        top: 20%;
                        right: -18%;
                        // margin: 5px 0 0 3px;
                        width: 30px;
                        height: 30px;
                        background: url(/photo/icon/点击.gif) no-repeat center;
                    }
                    // .img4 {
                    //     position: absolute;
                    //     top: 30%;
                    //     right: 35%;
                    //     margin: 5px 0 0 3px;
                    //     width: 30px;
                    //     height: 30px;
                    //     background: url(/photo/icon/1.gif) no-repeat center;
                    // }
                }
                @keyframes blink {
                    0% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                    }
                }
                .milieu {
                    margin-top: 8px;
                    letter-spacing: 1px;
                }
                .video {
                    margin-top: 10px;
                    font-size: 12px;
                }
            }
            .remark {
                margin: 20px 0 5px;
                color: #fff;
                font-weight: bold;
                font-size: 16px;
                letter-spacing: 1.5px;
            }
        }
        .hide {
            margin-left: 0;
        }
    }
    .application-place {
        width: 100%;
        background: #fff;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        .place-list {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            img {
                width: auto;
                height: 210px;
            }
        }
    }
    .process-move {
        width: 100%;
        height: 767px;
        background: url(/photo/icon/巡逻流程.gif) no-repeat center;
    }
}
</style>
